import React, {PropsWithChildren, Fragment} from "react";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {type IPubNubHocController} from "views/components/pub_nub_hoc/pub_nub_hoc.controller";
import {useNavigate} from "react-router-dom";

export const PubNubHoc: React.FC<PropsWithChildren> = observer(({children}) => {
	const navigate = useNavigate();
	useViewController<IPubNubHocController>(Bindings.PubNubHocController, {
		navigate,
	});

	return <Fragment>{children}</Fragment>;
});
